import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-139">
      <div className="max-w-3xl mx-auto" data-id="element-140">
        <div className="text-center mb-10" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-142">
            Si tu hijo tiene dificultades para aprender, no estás solo
          </h2>
          <p className="text-xl text-gray-700 font-medium" data-id="element-143">
            Muchos padres sienten preocupación cuando ven que su hijo:
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-10 border border-gray-100" data-id="element-144">
          <ul className="space-y-4" data-id="element-145">
            {['se distrae con facilidad', 'pierde el interés en las tareas escolares', 'tiene dificultades para leer', 'no comprende bien las matemáticas', 'se frustra cuando tiene que estudiar'].map((item, index) => <li key={index} className="flex items-center text-lg md:text-xl text-gray-800 font-medium" data-id="element-146">
                <AlertCircle className="h-6 w-6 text-red-500 mr-4 flex-shrink-0" data-id="element-147" />
                <span data-id="element-148">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center space-y-8" data-id="element-149">
          <div className="bg-black text-white p-8 rounded-xl transform -rotate-1" data-id="element-150">
            <p className="text-2xl md:text-3xl font-bold italic" data-id="element-151">
              "Quiero ayudarlo… pero no sé cómo."
            </p>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-152">
            <p data-id="element-153">
              La realidad es que los niños{' '}
              <span className="font-bold underline decoration-red-500" data-id="element-154">
                no aprenden todos de la misma manera
              </span>
              .
            </p>
            <p data-id="element-155">
              Cuando comprendemos cómo funciona su proceso de aprendizaje,
              podemos acompañarlos de forma mucho más efectiva.
            </p>
            <p className="font-bold text-2xl text-blue-600" data-id="element-156">
              Y eso es exactamente lo que encontrarás en este kit.
            </p>
          </div>
        </div>
      </div>
    </section>;
}